import React from "react";
import { isChildOfType } from "./is-child-of-type";
export function getPropsFromChildrenByType(children, component) {
    var props = [];
    var dfs = function (_children) {
        React.Children.forEach(_children, function (child) {
            if (isChildOfType(child, component)) {
                props.push(child.props);
            }
            else if (React.isValidElement(child) &&
                child.props.children) {
                dfs(child.props.children);
            }
        });
    };
    dfs(children);
    return props;
}
//# sourceMappingURL=get-props-from-children-by-type.js.map